// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1KED8","tab":"Tabs_tab__ljXM5","tabActive":"Tabs_tabActive__2PGXb"};